export const formatRows = (listaItems) => 
    listaItems.map((item) => ({
      id: item.id,
      aof_nombre: item.aof_nombre,
      aof_tipo: item.aof_tipo,
      aof_tipoprecio: item.aof_tipoprecio,
    }));
  